import React from 'react'
import c from 'classnames'
import { connect } from 'react-redux'

import Icon from 'discada/dist/Icon'
import { getBankByCode } from 'selectors/appStatusSelectors'

import './Bank.scss'

export function Bank({ name, className }) {
  if (!name) return null

  return (
    <span className={c('bank-name', className)}>
      <Icon icon="university" />
      &nbsp;
      <span>{name}</span>
    </span>
  )
}

function mapStateToProps(state, op) {
  return {
    ...op,
    name: getBankByCode(state, op.name),
  }
}

export default connect(mapStateToProps)(Bank)
